<template>
  <div class="priceWrapper mt-9">
    <div v-if="this.isShow">
      <v-card-text class="d-flex flex-wrap justify-center align-center">
        <div class="priceMobileCardWrapper mb-3 px-3" v-for="(item, i) in itemPrice" :key="i">
          <div class="priceMobileCard">
            <v-card :class="item.focus ? 'priceMobileCardFocus' : 'priceMobileCardTop'">
              <div class="priceMobileCardType">
                {{ item.character }}
              </div>
              <div style="min-height:100px">
                <div class="mobileListWrapper" v-for="(item, i) in item.description" :key="i">
                  <span>
                    <v-icon class="icon">mdi-check</v-icon>
                  </span>
                  <span class="listTitle">{{ $t(item) }}</span>
                </div>
                <div class="d-flex mb-4 justify-center">
                  <span class="price">{{ item.price
                  }}</span>
                  <span class="currency">₮</span>
                </div>
              </div>
              <div v-if="tablePrice">
                <v-card-actions class="justify-end">
                  <v-btn class="btnStyle" @click="buyPage(i)" :disabled="buyLoading == i">
                    <v-progress-circular v-if="buyLoading == i" :size="25" :width="3" color="#ffffff" indeterminate>
                    </v-progress-circular>
                    <span v-else style="color:#ffffff">{{
                        $t("footer.getPlanBtn")
                    }}</span>
                  </v-btn>
                </v-card-actions>
                </div>
                <div v-else class="priceLoaderWrapper">
                  <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
                </div>

            </v-card>
          </div>
        </div>
      </v-card-text>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "PricePage",
  data: () => ({
    quantity: 1,
    unitPrice: 0,
    totalPrice: 0,
    customerPlan: null,
    token: null,
    isShow: true,
    buyLoading: null,
    itemPrice: [{ character: "500 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "1,000" },
    { character: "5,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "5,000" },
    { character: "12,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "10,000" },
    { character: "25,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "20,000" },
    { character: "200,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "100,000" },
    { character: "2,000,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "800,000" }],
  }),
  watch: {
    quantity: function () {
      if (parseInt(this.quantity)) {
        let table = this.tablePrice[this.customerPlan.PlanID];
        for (let i = table.length - 1; i >= 0; i--) {
          if (table[i].PageCount <= this.quantity) {
            this.unitPrice = table[i].PagePrice;
            break;
          }
        }
        this.totalPrice = this.unitPrice * this.quantity;
      } else {
        this.unitPrice = this.tablePrice[this.customerPlan.PlanID][0].PagePrice;
        this.totalPrice = 0;
      }
    },
    tablePrice: function () {
      if (this.tablePrice != null && this.customerPlan != null) {
        this.isShow = true;
        this.unitPrice = this.tablePrice[this.customerPlan.PlanID][0].PagePrice;
        this.totalPrice = this.quantity * this.unitPrice;
      }
    },
    customerPlan: function () {
      if (this.tablePrice != null && this.customerPlan != null) {
        this.unitPrice = this.tablePrice[this.customerPlan.PlanID][0].PagePrice;
        this.totalPrice = this.quantity * this.unitPrice;

        this.isShow = true;
      }
    },
  },
  mounted() {
    this.token = this.$router.currentRoute.query.token;
    this.getCustomerPlan();
  },
  computed: {
    ...mapState(["tablePrice"]),
  },
  methods: {
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    plusFunc() {
      this.quantity++;
    },
    minusFunc() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    buyPage(value) {
      this.buyLoading = value;
      const headers = {
        token: this.token,
      };
      axios
        .put(`${process.env.VUE_APP_BASE_URL}/buy`, value+1, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            window.location.href = response.data.data.Url;
          }
          this.isPriceModal = false;
          this.buyLoading = null;
        })
        .catch((error) => {
          this.isPriceModal = false;
          this.buyLoading = null;
          this.checkError(error);
        });
    },
    getCustomerPlan() {
      const headers = { token: this.token };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getCustomerPlan`, {
          headers,
        })
        .then((response) => {
          this.customerPlan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          //   this.checkError(error);
        });
    },
  },
};
</script>

<style scoped>
.priceMobileWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  align-content: center;
}
.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
  width: 100%;
}
.priceMobileLoaderWrapper {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.priceMobileCardWrapper {
  width: 380px;
}

@media screen and (max-width: 650px) {
  .priceMobileCardWrapper {
    width: 300px;
  }
}

.priceMobileCard {
  /* min-height: 348px !important; */
  /* padding: 24px; */
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  border-bottom: 2px solid #adb5bd !important;
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
}

.priceMobileCardTop {
  min-height: 348px !important;
  padding: 24px;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #f7f6ff;
  color: #2a2a2b;
}

.priceMobileCardBottom {
  padding: 24px;
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 14px;
  color: #2c3e50aa;
}

.priceMobileCardBottomTitle {
  margin-bottom: 12px;
}

/* .priceMobileCard:hover {
  background-color: #ffffff;
  border-bottom: 3px solid #787ff7 !important;
  transition: all 0.5s ease !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15) !important;
} */

.priceMobileCardFocus {
  padding: 48px 24px;
  box-shadow: 0 0 10px rgba(60, 72, 88, 0.529) !important;
  /* border-bottom: 3px solid #adb5bd !important; */
  border-radius: 20px !important;
  transition: all 0.5s ease !important;
  background-color: #ffffff;
  color: #2a2a2b;
  border: 1px solid #787ff7;
}

.priceMobileCardType {
  font-weight: 700;
  /* color: #787ff7; */
  line-height: 1.5;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.price {
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
  font-size: 48px;
  color: #2c3e50;
}

.currency {
  font-weight: 700;
  line-height: 1.5;
  font-size: 24px;
  color: #2c3e50;
  margin-top: 7px;
}

.day {
  font-weight: 700;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-top: 11px;
}

.limit {
  font-weight: 500;
  text-align: right;
  line-height: 1.5;
  font-size: 9px;
  color: #2c3e50;
}

.mobileListWrapper {
  display: flex;
  align-items: left;
}

.icon {
  color: #787ff7;
  margin-right: 20px;
}

.listTitle {
  color: #2c3e50a6;
  font-weight: 500;
  line-height: 1.5;
  font-size: 16px;
  text-align: left;
}

.btnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 20px; */
  margin: 20px auto 0px auto;
}

.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
}

.instruction {
  display: inline-block;
  text-align: right;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 15px;
  padding-right: 20px;
}

.instructionCard {
  padding: 24px;
  border-bottom: 3px solid #adb5bd !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCard:hover {
  border-bottom: 3px solid #787ff7 !important;
  box-shadow: 0 0 3px rgba(60, 72, 88, 0.15) !important;
}

.instructionCardTitle {
  font-weight: 500;
  text-align: left;
  line-height: 1.5;
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 20px;
}

.instructionCardDesc {
  text-align: justify;
  line-height: 1.5;
  font-size: 16px;
  color: #2c3e50;
}

.dialogTextStyle {
  color: #2c3e50;
  /* color: red; */
  font-size: 16px;
}

.titleBar {
  font-weight: 500;
  font-size: 18px;
  border-bottom: 1px solid #e8e8e8;
  height: 58px !important;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.priceDialogStyle {
  font-weight: 700;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

td,
th {
  border: 1px solid #dddddda7;
  text-align: left;
  padding: 8px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 10px;
  height: 34px !important;
  width: 64px !important;
}
</style>
